/* eslint-disable jsx-a11y/no-access-key */
import React, {useEffect, useMemo, useRef, useState} from "react"
import {Collapse} from "@material-ui/core";
import style from "./style.module.sass"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {useTranslation} from "react-i18next";
import {convertJSONToObject, convertLanguagesToShort, handleDropClick, handleKeyDown, stripHtml} from "../../../utils"
import {useSelector} from "react-redux";
import { useTheme } from "@material-ui/core/styles"
import config from "../../../config";

export default function Fields({handleOnTextTypeChange}) {

    const {t, i18n: {language: i18nLanguage}} = useTranslation();
    const {theme: {bgColors, colors}} = useTheme()
    const enabledBenchmarks = useSelector(state => state.analyseData.enabledBenchmarks);
    const useBenchmark = useSelector(state => state.analyseData.useBenchmark);
    const storageLanguageTextType = convertJSONToObject(
        useSelector(
            (state) => state.userData?.user?.user_options?.analyse_language_texttype
        ),
        config.defaultAnalyseLanguageTextType
    )

    if (typeof storageLanguageTextType.textType !== 'object') {
        storageLanguageTextType.textType = {}
    }

    const shortLanguage = convertLanguagesToShort(i18nLanguage);
    const currentTextType = enabledBenchmarks[useBenchmark] || enabledBenchmarks[Object.keys(enabledBenchmarks)[0]]
    const description = useBenchmark > 0 ? enabledBenchmarks[useBenchmark]?.description[shortLanguage] : "";
    const [openDrop, setOpenDrop] = useState('')
    const [hoveredKey, setHoveredKey] = useState(null)
    const [textTypeFocusedKey, setTextTypeFocusedKey] = useState(null)
    const selectedRef = useRef(false)
    const benchmarkKeys = useMemo(() => Object.keys(enabledBenchmarks), [enabledBenchmarks])

    useEffect(() => {
        if(useBenchmark > 0 && benchmarkKeys.includes(useBenchmark.toString())) {
            setTextTypeFocusedKey(useBenchmark.toString())
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [useBenchmark])
    return (
        <div className={`${style.mainCont}`}>
            <div className={style.sliderCont} style={{backgroundColor: bgColors.bgPrimary0}}>
                {useBenchmark > 0 && <h3 style={{color: colors.colorPrimary500}} title={t('accessibility_analysis_text-type-selection')}>{t("Select text type")}</h3>}
                {useBenchmark > 0 ?
                    <div className={style.actions}>
                        <div onClick={() => handleDropClick('top', setOpenDrop, selectedRef)} tabIndex={config.tabIndexes.benchmarkSelection} accessKey={config.accessKeys.benchmarkSelectionTop}
                        onKeyDown={(e)=>handleKeyDown(e, textTypeFocusedKey, setTextTypeFocusedKey, benchmarkKeys, (key) => handleOnTextTypeChange(parseInt(key)), selectedRef, setOpenDrop, true)}
                             className={`${style.select}`}>
                            <div className={style.field} style={{backgroundColor:bgColors.bgPrimary600, color: colors.colorPrimary0}}>
                                <p>{currentTextType?.name[shortLanguage] || currentTextType?.id}</p>
                                <ExpandMoreIcon style={{transform: openDrop ? "rotate(180deg)" : "rotate(0deg)"}}/>
                            </div>
                            <Collapse className={`position-absolute full-width`} style={{zIndex: "5"}} in={openDrop}>
                                <ul style={{backgroundColor: bgColors.bgPrimary0}}>
                                    {Object.entries(enabledBenchmarks).map(([key, val]) =>
                                        <li key={key} onClick={() => {
                                            handleOnTextTypeChange(key)
                                        }} style={{ backgroundColor: key === textTypeFocusedKey ? bgColors.bgPrimary200 : 'transparent', color: key === hoveredKey ? colors.colorHover : colors.colorPrimary500 }}
                                            onMouseEnter={() => setHoveredKey(key)}
                                            onMouseLeave={() => setHoveredKey(null)}>
                                            {val['name'][shortLanguage] || key}
                                        </li>
                                    )}
                                </ul>
                            </Collapse>
                        </div>
                        <p className={style.desc} style={{color: colors.colorPrimary500}} >{description}</p>
                    </div>
                    :
                    <div className={style.warning} style={{color: colors.colorPrimary500}} dangerouslySetInnerHTML={{__html: stripHtml(t("No benchmark top warning"),config.dangerousTags)}}/>
                }
            </div>
        </div>
    )
}
